import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["LoginForm"] */ "/vercel/path0/src/app/auth/login/ui/LoginForm.tsx");
